"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";

export function ContactFormHomePageMessages({
  showError = true,
  showSuccess = true,
}) {
  return (
    <Block className={"contact-form---messages"} tag={"div"}>
      {showSuccess ? (
        <Block className={"success-message black"} tag={"div"}>
          <Paragraph>
            {
              "Success - Your message has been sent. Someone will be in contact with you soon."
            }
          </Paragraph>
        </Block>
      ) : null}
      {showError ? (
        <Block className={"error-message black"} tag={"div"}>
          <Paragraph>
            {"Hummm ... Something went wrong. Can you try again. "}
          </Paragraph>
        </Block>
      ) : null}
    </Block>
  );
}
